import fileDownload from 'js-file-download';
import moment from 'moment';

class FaultCsvController {
  constructor(EquipmentService, usersService) {
    'ngInject';
    this.equipmentService = EquipmentService;
    this.usersService = usersService;
  }

  getSeriesData(seconds = 60) {
    const timeRange = this.getTimeRange(seconds);
    this.equipmentService.getTimeseriesCsvData(this.id, timeRange).then((response) => {
      fileDownload(response.data, `${this.id}_TimeSlice.csv`);
    });

    this.csvDownloaded({ alert: this.alert });
  }

  getTimeRange(seconds) {
    const startRange = moment(this.timestamp).subtract(seconds, 'seconds').toISOString();
    const endRange = moment(this.timestamp).add(seconds, 'seconds').toISOString();
    return startRange + '/' + endRange;
  }
}

export const FaultCsvComponent = {
  template: require('./fault-csv.template.html'),
  controller: FaultCsvController,
  controllerAs: 'vm',
  bindings: {
    id: '<',
    timestamp: '<',
    csvDownloaded: '&',
    alert: '<',
  },
};
